module.exports = __webpack_public_path__ + "a37454ec4e308be2918eef1eafa26028.jpg";